import { Select, MenuItem, FormControl, InputLabel, Chip, FormHelperText } from '@mui/material'
import type { FieldMeta } from '@crm/shared'

interface EnumFieldProps {
  field: FieldMeta
  value: unknown
  mode: 'view' | 'edit'
  onChange?: (value: unknown) => void
  error?: string
  disabled?: boolean
  hideLabel?: boolean
}

function getOptions(field: FieldMeta): Array<{ value: string; label: string }> {
  if (!field.options) return []
  try {
    const parsed = JSON.parse(field.options as unknown as string)
    return parsed.options ?? parsed
  } catch {
    return []
  }
}

export function EnumField({ field, value, mode, onChange, error, disabled, hideLabel }: EnumFieldProps) {
  const options = getOptions(field)

  if (mode === 'view') {
    if (value == null) return <span />
    const opt = options.find((o) => o.value === String(value))
    return <Chip label={opt?.label ?? String(value)} size="small" variant="outlined" />
  }

  return (
    <FormControl size="small" fullWidth error={!!error} required={!!field.is_required} disabled={disabled}>
      {!hideLabel && <InputLabel>{field.label}</InputLabel>}
      <Select
        value={value ?? ''}
        onChange={(e) => onChange?.(e.target.value)}
        label={hideLabel ? undefined : field.label}
      >
        <MenuItem value=""><em>None</em></MenuItem>
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  )
}
